import visit from 'unist-util-visit';
import stringify from 'nlcst-to-string';
import { TextAnalysis, TextAnalysisCategory, TextAnalysisResult } from '../SermonAnalyzer';

export default function ScriptureSaturation() {

    const scriptureRegex = `(?:Genesis|1 Kings|2 Kings|1 Timothy|2 Timothy|1 Peter|2 Peter|1 Samuel|2 Samuel|1 John|2 John|3 John|1 Chronicles|2 Chronicles|1 Corinthians|2 Corinthians|1 Thessalonians|2 Thessalonians|I Kings|II Kings|I Timothy|II Timothy|I Peter|II Peter|I Samuel|II Samuel|I John|II John|III John|I Chronicles|II Chronicles|I Corinthians|II Corinthians|I Thessalonians|Thessalonians|Exodus|Leviticus|Numbers|Deuteronomy|Joshua|Judges|Ruth|Ezra|Nehemiah|Esther|Job|Psalms?|Proverbs?|Ecclesiastes|Songs? of Solomon|Song of Songs|Isaiah|Jeremiah|Lamentations|Ezekiel|Daniel|Hosea|Joel|Amos|Obadiah|Jonah|Micah|Nahum|Habakkuk|Zephaniah|Haggai|Zechariah|Malachi|Matt|Matthew|Mark|Luke|John|Acts?|Acts of the Apostles|Romans|Galatians|Ephesians|Phil+ippians|Colossians|Titus|Philemon|Hebrews|James|Jude|Revelations?)\\s\\d{1,3}(?::\\d{1,3})?(?:\\s?(?:[-&]\\s?(?:\\d{1,3}:)?\\d+))*`;
    const scriptureReferenceRegex = new RegExp(scriptureRegex, "gi");

    let scriputreReferences:string[] = [];
    let scriptureReferenceCount:number = 0;
    let totalWordCount:number = 0;

    return transformer;
    
    function transformer(tree: any, file: any) {
        visit(tree, 'SentenceNode', gather);
        
        function gather(sentence: any) {
            let value:string = stringify(sentence);
            
            if(scriptureReferenceRegex.test(value)){
                scriptureReferenceCount++;
                
                let refs = value.match(scriptureReferenceRegex);
                
                if (refs !== null){
                    refs.forEach( ref => scriputreReferences.push(ref));
                }
            }

            totalWordCount += sentence.children.filter((c:any) => c.type === "WordNode" ).length;
            return visit.SKIP;
        }

        let scriptureReferenceAvg:number = scriptureReferenceCount > 0 ? scriptureReferenceCount / totalWordCount : 0;

        let scriptureSaturation = getScriptureSaturation(scriptureReferenceAvg);
        
        if(scriptureSaturation.result === TextAnalysisResult.improvement){ 
            file.improvements.push(scriptureSaturation);
        } else { 
            file.goodResults.push(scriptureSaturation);
        }

        file.scriptureReferences = scriputreReferences;
    }
    
    function getScriptureSaturation(percentage:number){
        let result:TextAnalysis = {title: TextAnalysisCategory.scripture_saturation, displayText: '', helperText: "Based on the number of Scripture references found"};
        if (percentage === 0) { 
            result.result = TextAnalysisResult.improvement;
            result.color = "#ff0000" ;
            result.displayText = "No Scripture";
        } else if (percentage >= .01) {
            result.result = TextAnalysisResult.goodResult;
            result.color = "#006600";
            result.displayText = "Heavy Scripture";
        } else if (percentage >= .004) {
            result.result = TextAnalysisResult.goodResult;
            result.color = "#009900";
            result.displayText = "Solid Scripture";
        } else if (percentage >= .001) {
            result.result = TextAnalysisResult.goodResult;
            result.color = "#00ff00" ;
            result.displayText = "Light Scripture";
        } else {
            result.result = TextAnalysisResult.improvement;
            result.color = "#ff0000" ;
            result.displayText = "Needs Scripture";
        }
        return result;
    }
}


